import { render, staticRenderFns } from "./_base-tooltip.vue?vue&type=template&id=47b30ba7&lang=pug&"
import script from "./_base-tooltip.vue?vue&type=script&lang=js&"
export * from "./_base-tooltip.vue?vue&type=script&lang=js&"
import style0 from "./_base-tooltip.vue?vue&type=style&index=0&id=47b30ba7&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports